export default "__VITE_ASSET__Cl7Se7rL__"